export default {"src":"/_next/static/media/avatar_24.a1b57a65.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};